import { Table, Tag, Space, message } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import EditButton from "../../UI/EditButton/editbutton";
import DeleteButton from "../../UI/DeleteButton/deletebutton";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import DeleteModal from "../../UI/ModalComponent/DeleteModal/deletemodal";
import { AxiosResponse } from "axios";

import { AddEditDelivery } from "./AddEditDelivery";
import { DeliveryType } from "./deliveryType";
import { deleteDelivery, getDeliveryById } from "../../../api/refDelivery";

interface inventoryProps {
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  filter: boolean | undefined;
  search: string;
  isGetDeliveriesLoading: boolean;
  paginatedtDelivery: any;
  setPaginatedtDelivery: Dispatch<any>;
  getDeliveriesMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  tableKey: string;
}
interface ComponentInterface {
  id: string;
  name: string;
  isActive: boolean;
}
const DeliveryList = ({
  page,
  search,
  setPage,
  filter,
  isGetDeliveriesLoading,
  paginatedtDelivery,
  setPaginatedtDelivery,
  getDeliveriesMutation,
  tableKey,
}: inventoryProps) => {
  const [t] = useTranslation("common");
  const [selectComponent, setSelectedComponent] = useState<any>();
  const [openDelivery, setOpenDelivery] = useState(false);
  const [component, setComponent] = useState<DeliveryType>();
  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);
  const getgetDeliveriesMutation = useMutation("getComponen", getDeliveryById);
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);
  const [nameToDelete, setNameToDelete] = useState<any>();
  const [, setError] = useState("");

  useEffect(() => {
    page > prevPage &&
      maxPage < page &&
      getDeliveriesMutation({
        limit: page * 8 + 8,
        q: search,
        isActive: filter,
      }).then((res) => {
        if (page > maxPage) setMaxPage(page);
        setPaginatedtDelivery(res.data?.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filter]);

  const onError = (error: any, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };

  function fillComponent(id: any) {
    getgetDeliveriesMutation.mutate(id, {
      onSuccess: (res) => {
        setComponent(res.data);
        setOpenDelivery(true);
      },
    });
  }

  const deleteDeliveryMutation = useMutation(
    "deleteDelivery",
    deleteDelivery,
    {
      onSuccess: (res) => {
        message.success(res.data.message)
        getDeliveriesMutation({
          limit: page * 8 + 8,
          q: search,
          isActive: filter,
        })
          .then((res) => {
            setPaginatedtDelivery(res.data?.data);
          });
      },
      onError,
    }
  );

  const DeleteCurrency = (id: string | undefined, name: string): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(name);
  };

  const handleOk = () => {
    if (idToDelete) {
      deleteDeliveryMutation.mutate({ id: idToDelete });
    }
    setOpen(false);
  };

  const columns: ColumnsType<ComponentInterface> = [
    {
      title: `${t("location")}`,
      dataIndex: "location",
      key: "location",
      className: "table-header",
      width: '10rem'
    },
    {
      title: `${t("amount")}`,
      dataIndex: "amountText",
      key: "amountText",
      className: "table-header"
    },
    {
      title: `${t("status")}`,
      dataIndex: "isActive",
      align: "center",
      width: "5rem",
      key: "isActive",
      render: (record: any) =>
        record ? (
          <Tag className="active">Active</Tag>
        ) : (
          <Tag className="inactive">Inactive</Tag>
        ),
    },
    {
      title: `${t("action")}`,
      key: "action",
      fixed: "right",
      width: "5rem",
      align: "center",
      render: (record: any) => {
        const canBeDeleted = record.canBeDeleted
        return (
          <Space>
            <EditButton
              onClick={() => {
                setSelectedComponent(record.id);
                fillComponent(record.id);
              }}
            />
            <DeleteButton
              onClick={() => DeleteCurrency(record?.id, record?.name)}
              disabled={!canBeDeleted}
            />
          </Space>
        )
      },
    },
  ];

  return (
    <>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={nameToDelete}
        onOk={handleOk}
      />
      {openDelivery && component && (
        <AddEditDelivery
          component={component}
          openDelivery={openDelivery}
          setOpenDelivery={setOpenDelivery}
          id={selectComponent}
          setPaginatedtDelivery={setPaginatedtDelivery}
          getDeliveriesMutation={getDeliveriesMutation}
          page={page}
          filter={filter}
          search={search}
        />
      )}

      <Table
        key={tableKey}
        columns={columns}
        dataSource={paginatedtDelivery}
        loading={isGetDeliveriesLoading}
        pagination={{ pageSize: 8 }}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        onChange={(selectedPage) => {
          setPrevPage(page);
          setPage(selectedPage?.current ?? 1);
        }}
        rowKey={(record) => record.id}
      />
    </>
  );
};

export default DeliveryList;
